import { render } from "./CxSurfaceLogDetailsPanel.vue?vue&type=template&id=72aeacf2"
import script from "./CxSurfaceLogDetailsPanel.vue?vue&type=script&lang=js"
export * from "./CxSurfaceLogDetailsPanel.vue?vue&type=script&lang=js"

import "./CxSurfaceLogDetailsPanel.vue?vue&type=style&index=0&id=72aeacf2&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__